<template>
  <tr class="slds-hint-parent">
    <td>
      <button class="slds-button slds-button_icon slds-button_icon-error" @click="$emit('removeContent', { index })" v-if="editable">
        <svg class="slds-button__icon" aria-hidden="true">
          <use xlink:href="../../../../assets/symbols.svg#delete"></use>
        </svg>
      </button>
    </td>
    <td>
      <Input v-model="localContent.description" v-if="editable" :validation="['required', { name: 'no-duplicate-content', param: { contents, index } }]" ref="description" />
      <span v-else>{{localContent.description}}</span>
    </td>
    <template v-if="editable">
      <td>
        <Picklist
          :options="contentPriorityOptions"
          :validation="['required']"
          ref="contentPriority"
          labels-prefix="campaignDesigner.contentSelectionAndTag.contentPriority"
          small
          v-model="contentPriority" />
      </td>
      <td>
        <Picklist
          :options="firstTagOptions"
          :validation="['required']"
          ref="tag_0"
          small
          v-if="editable"
          v-model="firstTag" />
      </td>
      <td>
        <Picklist
          :disabled="!firstTag || !secondTagOptions"
          :options="secondTagOptions"
          :validation="['required']"
          ref="tag_1"
          small
          v-model="secondTag" />
      </td>
      <td>
        <Picklist
          :disabled="!firstTag || !secondTag || !thirdTagOptions"
          :options="thirdTagOptions"
          :validation="['required']"
          ref="tag_2"
          small
          v-model="thirdTag" />
      </td>
    </template>
    <template v-else>
      <td>
        {{$t(`campaignDesigner.contentSelectionAndTag.contentPriority.${localContent.contentPriority}`)}}
      </td>
      <td colspan="3">
        <OutputField type="array" :value="[firstTag.label, secondTag.label, thirdTag.label]" />
      </td>
    </template>
  </tr>
</template>
<script>
import { getTags } from './tagUtils'
import Input from '../../../slds/Input'
import OutputField from '../../../slds/OutputField'
import Picklist from '../../../slds/Picklist'
export default {
  components: {
    Input,
    OutputField,
    Picklist
  },
  created () {
    this.localContent = this.content
    const { tags } = this.content
    this.firstTagOptions = getTags(this.tags)

    if (tags[0]) {
      this.secondTagOptions = getTags(this.tags, [tags[0]])

      if (tags[1]) {
        this.thirdTagOptions = getTags(this.tags, [tags[0], tags[1]])
      }
    }
  },
  mounted () {
    const { tags, contentPriority } = this.content

    this.contentPriority = contentPriority
    if (tags[0]) {
      this.firstTag = tags[0]

      if (tags[1]) {
        this.secondTag = tags[1]

        this.$nextTick(() => {
          if (tags[2]) {
            this.thirdTag = tags[2]
          }
        })
      }
    }
    this.$nextTick(() => {
      this.mounted = true
    })
  },
  data () {
    return {
      contentPriority: '',
      contentPriorityOptions: [
        'primary',
        'secondary',
        'tertiary'
      ],
      firstTag: '',
      firstTagOptions: [],
      mounted: false,
      secondTag: '',
      secondTagOptions: [],
      thirdTag: '',
      thirdTagOptions: [],
      localContent: {}
    }
  },
  props: {
    content: Object,
    contents: Array,
    editable: Boolean,
    index: Number,
    tags: Array
  },
  methods: {
    updateTagsOnContent (position, value) {
      this.$emit('tagUpdate', { index: this.index, position, value })
    },
    validate () {
      const validationResult = [
        this.$refs.contentPriority.validate(),
        this.$refs.tag_0.validate(),
        this.$refs.tag_1.disabled || this.$refs.tag_1.validate(),
        this.$refs.tag_2.disabled || this.$refs.tag_2.validate()
      ]
      return validationResult.every(v => v)
    }
  },
  watch: {
    content (content) {
      this.localContent = content
    },
    contentPriority (contentPriority) {
      this.$emit('update-content-priority', { value: contentPriority, index: this.index })
    },
    firstTag (tag) {
      if (this.mounted && tag) {
        this.secondTagOptions = getTags(this.tags, [tag])
        this.thirdTagOptions = []
        this.secondTag = ''
        this.thirdTag = ''
        this.updateTagsOnContent(0, tag)
        if (this.$refs.clearValidationError) {
          this.$refs.description.clearValidationError()
        }
      }
    },
    secondTag (tag) {
      if (this.mounted && tag) {
        this.thirdTag = ''
        this.thirdTagOptions = getTags(this.tags, [this.firstTag, tag])
        this.updateTagsOnContent(1, tag)
        if (this.$refs.clearValidationError) {
          this.$refs.description.clearValidationError()
        }
      }
    },
    thirdTag (tag) {
      if (this.mounted && tag) {
        this.updateTagsOnContent(2, tag)
        if (this.$refs.clearValidationError) {
          this.$refs.description.clearValidationError()
        }
      }
    }
  }
}
</script>
